import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { POPUP } from 'utils/constants/popup';
import { openPopup } from 'modules/popup/actions';
import scanDate from 'assets/icons/scan_date.svg';
import scheduleACall from 'assets/icons/schedule_a_call.svg';
import updateProfile from 'assets/icons/update_profile.svg';
import shareWithYourDoctor from 'assets/icons/share_with_doctor.svg';
import { CHAT_ROLES, MESSAGE_TYPES } from '../../constants';
import './actionPanel.css';

const shareWithYourDoctorHandler = ({ addMessages, setShowChatNextScan, dispatch }) => {
  setShowChatNextScan(false);

  const content = [{
    type: MESSAGE_TYPES.REACT_NODE,
    content: (
      <>
        We founded this company to provide patients with hope by offering a variety of treatment options.
        Your oncologist and their clinic are eager to receive these treatment options from you.
        We strongly recommend discussing these options with your doctor.
        Simply click on the following link to send your doctor the treatment options:
        <button
          className="chat-link-button"
          type="button"
          onClick={() => {
            dispatch(openPopup({ type: POPUP.SHARE_WITH_MY_DOCTOR }));
          }}
        >
          Share with your doctor
        </button>
      </>
    ),
  }];

  addMessages([{ role: CHAT_ROLES.TINA, content }]);
};

const scheduleACallHandler = ({
  addMessages,
  setShowChatNextScan,
  dispatch,
}) => {
  setShowChatNextScan(false);

  const phraseResponse = 'Our team would love to help you, just schedule a call in the following link: ';
  const actionButton = (
    <button
      className="chat-link-button"
      type="button"
      onClick={() => {
        dispatch(openPopup({ type: POPUP.CONSULT_WITH_US }));
      }}
    >
      Schedule a call
    </button>
  );
  addMessages([{
    role: CHAT_ROLES.TINA,
    content: [{
      type: MESSAGE_TYPES.REACT_NODE,
      content: (
        <>
          {phraseResponse}
          {actionButton}
        </>
      ),
    }],
  }]);
};

const handleChatActionButtonClicked = ({ onClick, key }) => {
  const clickedButton = document.querySelector(`[data-key="${key}"]`);
  if (clickedButton) {
    clickedButton.classList.add('chat-active-action-panel-button');
  }

  const otherButtons = document.querySelectorAll('.chat-actions-panel-button');
  if (otherButtons) {
    otherButtons.forEach((button) => {
      if (button !== clickedButton) {
        button.classList.remove('chat-active-action-panel-button');
      }
    });
  }

  onClick();
};

export const ActionPanel = ({
  loading, hasSponsoredTrial, addMessages, setShowChatNextScan,
}) => {
  const dispatch = useDispatch();
  const chatActionsButtons = [
    {
      key: 'update_scan_date',
      icon: scanDate,
      alt: 'Update Scan Date',
      label: 'Update Scan Date',
      onClick: () => {
        setShowChatNextScan(true);
        addMessages([{
          role: CHAT_ROLES.TINA,
          content: 'Please share with us your last scan date',
        }]);
      },
    },
    {
      key: 'share_with_doctor',
      icon: shareWithYourDoctor,
      alt: 'Share with your doctor',
      label: 'Share with your doctor',
      onClick: () => shareWithYourDoctorHandler({ addMessages, setShowChatNextScan, dispatch }),
    },
    hasSponsoredTrial ? {
      key: 'schedule_call',
      icon: scheduleACall,
      alt: 'Schedule A Call',
      label: 'Schedule A Call',
      onClick: () => scheduleACallHandler({
        addMessages,
        setShowChatNextScan,
        dispatch,
      }),
    } : {
      key: 'update_profile',
      icon: updateProfile,
      alt: 'Update profile',
      label: 'Update profile',
      onClick: () => {
        dispatch(openPopup({ type: POPUP.MEDICAL_PROFILE }));
      },
    },
  ];

  return (
    <div className="chat-actions-panel-fullmode">
      <div className="chat-actions-panel-buttons">
        {chatActionsButtons.map(({
          onClick, key, icon, alt, label,
        }) => (
          <button
            key={key}
            data-key={key}
            type="button"
            disabled={loading}
            title={alt}
            className="chat-actions-panel-button"
            onClick={() => {
              handleChatActionButtonClicked({ onClick, key });
            }}
          >
            <img className="chat-actions-panel-icon" src={icon} alt={alt} />
            <br />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

ActionPanel.propTypes = {
  hasSponsoredTrial: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  addMessages: PropTypes.func.isRequired,
  setShowChatNextScan: PropTypes.func.isRequired,
};
